module.exports = __webpack_public_path__ + "static/media/4.d94f7b93.jpg";